import { IFormatter } from '../FormatterTypes';
import { TEDValidateDefault } from '../Validators/TEDValidateDefault';
import { TEDParseCase } from '../Parsers/TEDParseCase';
import { TEDDisplayDefault } from '../Displayers/TEDDisplayDefault';

export class TEDFormatCase implements IFormatter {
  displayer = TEDDisplayDefault.getInstance();
  parser = TEDParseCase.getInstance();
  validator = TEDValidateDefault.getInstance();
}
